import {
    Infinity as InfinityIcon,
    ShieldCheck,
    Coins,
    Zap,
    Headphones,
    Activity,
    BadgeCheck,
    TrendingDown,
} from "lucide-react";
import { useSiteT } from "../../hooks/useSiteT";

const ICONS = [TrendingDown, Coins, ShieldCheck, Activity, Zap, BadgeCheck, InfinityIcon, Headphones];
const BENEFITS = {
    tr: [
        ["Büyüdükçe düşen fee", "Aylık abonelik yok. White-hat komisyon %2.5'ten %1'e, gray-hat %4'ten %2'ye iner. Hacim büyüdükçe maliyet düşer."],
        ["$1M üzeri %0.5–3 Cashback", "Whale seviyesinde ilişki tersine döner: Adrise, çevirdiğiniz hacim için size aylık USDT cashback öder."],
        ["Whitelisted operasyon stabilitesi", "Meta, Google ve TikTok tarafında daha güçlü güven katmanı ve operasyonel eskalasyon yolu."],
        ["Pixel verisi koruma altında", "Güçlendirilmiş BM yapısı sayesinde hesap değişimlerinde pixel ve veri setleriniz korunur."],
        ["Dakikalar içinde top-up", "Kripto top-up 1–3 dakikada onaylanır. Banka beklemesi ve kart redleri yok."],
        ["Çoklu dikey operasyon desteği", "E-ticaret, SaaS, B2B ve seçili performans dikeylerinde uyum odaklı operasyon akışları sunulur."],
        ["Hızlı operasyonel yedeklilik", "Operasyon aksarsa hızlı hesap geçişi ve bakiye sürekliliği süreçleri uygulanır."],
        ["7/24 WhatsApp & Telegram desteği", "Gerçek operasyon ekibi, doğrudan mesajlaşma — ortalama yanıt süresi 3 dakika."],
    ],
    en: [
        ["Fees that drop as you scale", "No monthly subscription. White-hat drops from 2.5% to 1%, gray-hat from 4% to 2% as volume grows."],
        ["up to 3% cashback above $1M", "At Whale tier, Adrise pays monthly USDT cashback based on your processed spend."],
        ["Whitelisted stability", "Platinum HIVA Partner inventory with stronger trust and escalation paths."],
        ["Pixel data protection", "Asset architecture helps preserve tracking continuity during account transitions."],
        ["Top-ups in minutes", "Crypto confirmations in 1–3 minutes. No bank delays, no card declines."],
        ["White-hat and gray-hat ready", "Supports broad verticals including eCom, SaaS, finance, crypto, nutra and more."],
        ["Unlimited replacements", "If disruption occurs, replacement and balance transfer are handled quickly."],
        ["24/7 WhatsApp & Telegram support", "Dedicated operations team on direct chat — average response time 3 minutes."],
    ],
    es: [
        ["Comisiones que bajan al escalar", "Sin suscripción mensual. White-hat baja del 2.5% al 1%, gray-hat del 4% al 2% a medida que crece el volumen."],
        ["hasta 3% de cashback por encima de $1M", "En el nivel Whale, Adrise te paga cashback mensual en USDT según tu gasto procesado."],
        ["Estabilidad whitelisted", "Inventario Platinum HIVA Partner con mayor confianza y vías de escalado."],
        ["Protección de datos del píxel", "La arquitectura de activos preserva la continuidad del tracking durante las transiciones de cuenta."],
        ["Recargas en minutos", "Confirmaciones cripto en 1–3 minutos. Sin esperas bancarias ni rechazos de tarjeta."],
        ["Listo para white-hat y gray-hat", "Soporta verticales amplias: eCom, SaaS, finanzas, cripto, nutra y más."],
        ["Reemplazos ilimitados", "Si hay una interrupción, el reemplazo y el traspaso de saldo se gestionan rápidamente."],
        ["Soporte 24/7 por WhatsApp y Telegram", "Equipo de operaciones dedicado en chat directo — tiempo medio de respuesta 3 minutos."],
    ],
    pt: [
        ["Taxas que caem conforme você escala", "Sem assinatura mensal. White-hat cai de 2.5% para 1%, gray-hat de 4% para 2% conforme o volume cresce."],
        ["até 3% de cashback acima de $1M", "No nível Whale, a Adrise paga cashback mensal em USDT com base no seu gasto processado."],
        ["Estabilidade whitelisted", "Inventário Platinum HIVA Partner com mais confiança e caminhos de escalonamento."],
        ["Proteção dos dados do pixel", "A arquitetura de ativos preserva a continuidade do tracking durante transições de conta."],
        ["Recargas em minutos", "Confirmações cripto em 1–3 minutos. Sem espera bancária nem recusas de cartão."],
        ["Pronto para white-hat e gray-hat", "Suporta verticais amplas: eCom, SaaS, finanças, cripto, nutra e mais."],
        ["Substituições ilimitadas", "Se houver interrupção, substituição e transferência de saldo são tratadas rapidamente."],
        ["Suporte 24/7 por WhatsApp e Telegram", "Equipe de operações dedicada em chat direto — tempo médio de resposta de 3 minutos."],
    ],
    ru: [
        ["Комиссии снижаются с ростом", "Без ежемесячной подписки. White-hat снижается с 2.5% до 1%, gray-hat — с 4% до 2% по мере роста объёма."],
        ["Кэшбэк до 3% свыше $1M", "На уровне Whale Adrise ежемесячно выплачивает кэшбэк в USDT с вашего обработанного расхода."],
        ["Whitelisted-стабильность", "Инвентарь Platinum HIVA Partner с более высоким доверием и каналами эскалации."],
        ["Защита данных пикселя", "Архитектура активов сохраняет непрерывность трекинга при переходах между аккаунтами."],
        ["Пополнение за минуты", "Крипто-подтверждения за 1–3 минуты. Без банковских задержек и отказов карт."],
        ["Готовность к white-hat и gray-hat", "Поддержка широких вертикалей: eCom, SaaS, финансы, крипто, нутра и другие."],
        ["Неограниченные замены", "При сбое замена и перенос баланса выполняются быстро."],
        ["Поддержка 24/7 в WhatsApp и Telegram", "Выделенная операционная команда в прямом чате — среднее время ответа 3 минуты."],
    ],
};

export default function BenefitsBento() {
    const { t, pick } = useSiteT();
    const benefits = pick(BENEFITS).map(([title, text], i) => ({ title, text, Icon: ICONS[i] }));

    return (
        <section id="benefits" data-testid="benefits-section" className="py-24 md:py-32 relative">
            <div className="container-skala grid lg:grid-cols-12 gap-10 lg:gap-16">
                <div className="lg:col-span-4">
                    <div className="lg:sticky lg:top-32 space-y-5">
                        <div className="inline-flex items-center gap-2">
                            <span className="h-px w-8 bg-primary" />
                            <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-primary">{t("bn.eyebrow")}</p>
                        </div>
                        <h2 className="font-display font-bold text-4xl md:text-5xl tracking-tight leading-[1.05]">
                            {t("bn.h1")}<br />{t("bn.h2")}
                        </h2>
                        <p className="text-muted-foreground text-base md:text-lg leading-relaxed">{t("bn.sub")}</p>
                    </div>
                </div>

                <div className="lg:col-span-8">
                    <div className="divide-y divide-white/[0.07] border-t border-white/[0.07]">
                        {benefits.map((b, i) => (
                            <article key={i} data-testid={`benefit-card-${i}`} className="group grid grid-cols-[auto_1fr] gap-5 md:gap-7 py-7 md:py-8 transition-colors">
                                <div className="flex flex-col items-center gap-3">
                                    <span className="font-display font-bold text-lg text-primary/70 tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                                    <span className="w-10 h-10 rounded-lg border border-primary/20 bg-primary/[0.06] grid place-items-center group-hover:bg-primary/10 transition-colors">
                                        <b.Icon className="w-5 h-5 text-primary" />
                                    </span>
                                </div>
                                <div>
                                    <h3 className="font-display font-semibold text-xl md:text-2xl mb-1.5 group-hover:text-primary transition-colors">{b.title}</h3>
                                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed max-w-2xl">{b.text}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
